import styled from 'styled-components';

export const Contain = styled.div`
  flex: 1;
  height: 60%;
  display: flex;
  flex-direction: column;
`;

export const List = styled.div`
  height: 100%;
  overflow-y: scroll;
`;

export const CheckboxContainer = styled.div`
  padding: 8px 15px;
  background-color: #cfcfcf80;
  border-radius: 3px;
`;

export default {
  panel: {
    'height': 'calc(100% - 35px)',
    'overflowY': 'scroll'
  }
}
